// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"1a4e3337","239":"a61e283e","361":"96cef690","453":"260540bc","455":"2aef3a42","762":"984cf200"}[chunkId] + ".chunk.js";
};